<template>
  <div class="make-payment-container">
    <div id="top-target" class="eicproduct-success-fail">
      <div class="eicproduct-success__intro-image">
        <img class="my-account__payment-plan-icon" src="/wp-content/themes/gmptwentynineteen/assets/images/panel-upgrade-funding-success.svg" alt="electric panel submission success" />
      </div>

      <h2 class="gds-display-2 gds-align--text-center gds-space-stack-ml">Thank you!</h2>
      <div class="gds-font-size-l gds-space-stack-l successBody">We have your received your electric panel grant request and will contact you shortly!</div>
      <div class="rebate-success__button-wrap gds-align--text-center">
        <button @click="ReturnToSender()" type="button" class="eicproduct-done__button gds-button">Done</button>
      </div>
    </div>
  </div>
</template>

<script>
import { GMPPhoneNumber } from "../../../environment";
import { ReturnToSender } from "../../../utilities";
import UtilitiesMixin from '../../mixins/UtilitiesMixin';

export default {
  name: "ElectricPanelComplete",
  mixins: [
    UtilitiesMixin,
  ],
  data() {
    return {
      ReturnToSender,
      GMPPhoneNumber,
    };
  },
  async mounted() {
    this.scrollToTop('top-target');
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>